module.exports = __webpack_public_path__ + "img/pc.899c5a2b.png";